module.exports = __webpack_public_path__ + "img/banner-m-menu.png";